// GameContainer.jsx
import React, { useState, useEffect } from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import QuickScoringMobile from "./QuickScoringMobile";
import ScoreBoard from "./ScoreBoard";
import TeamPanelForm from "./TeamPanelForm";
import GameClock from "./GameClock";
import {
    initGame,
    saveEvent,
    setGameState,
    getGameState,
    fetchGameStateFromFirestore,
    saveClockTimestamps,
    getClockTimestamps,
    syncOfflineEvents,
    calcularTiempoAcumulado
} from "./gameStorage";
import EventViewer from "./EventViewer";
import { useDispatch, useSelector } from "react-redux";
import { saveGameData, listenToGameData, listenToGameEvents } from "../../../data-store/actions/teamgames-actions";
import { useParams } from "react-router-dom";

// TODOS
// Reporte general del evento (puntos por atleta, faltas, tiempo en cancha etc)
// en esa vista agregar perfil de anotador y perfil de coach para que el coash registre al equipo
// Link público del juego
// respaldo en local de toda la bitacora



const GameContainer = () => {
    const [currentPeriod, setCurrentPeriod] = useState(1);
    const [gameStats, setGameStats] = useState(false);
    const [openFormTeam, setOpenFormTeam] = useState(null);
    const [initialElapsedTime, setInitialElapsedTime] = useState(0);

    const currentPeriodIndex = parseInt(currentPeriod) - 1;

    const gameData = useSelector((state) => state.teamgames.gameData);
    const gameEvents = useSelector((state) => state.teamgames.gameEvents);

    const { gameId } = useParams();

    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = dispatch(listenToGameData(gameId));
        // Limpia el listener al desmontar
        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [dispatch, gameId]);
    useEffect(() => {
        const unsubscribe = dispatch(listenToGameEvents(gameId));

        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [dispatch, gameId]);
    useEffect(() => {
        if (gameData && gameData.estado) {
            setGameStats(generarResumenPorEquipo(gameEvents));

        }
    }, [gameEvents, gameData]);

    console.log("generarResumenPorEquipo", gameStats);


    useEffect(() => {
        initGame(gameId);
        // syncOfflineEvents();
        // window.addEventListener("online", syncOfflineEvents);

        // const restoreFromState = (state) => {
        //     setCurrentPeriod(state.currentPeriod);
        // };

        // const stored = getGameState();
        // if (stored) {
        //     restoreFromState(stored);
        // } else {
        //     fetchGameStateFromFirestore().then((state) => {
        //         if (state) restoreFromState(state);
        //     });
        // }

        // calcularTiempoAcumulado("1").then(setInitialElapsedTime);

        // return () => window.removeEventListener("online", syncOfflineEvents);
    }, []);



    function generarResumenPorEquipo(eventos) {
        const resumen = {
            currentPeriod: 1
        }



        resumen["A"] = {
            totalPuntos: 0,
            porCuarto: {},  // {1: 10, 2: 5, ...}
            players: gameData.estado[`teamAInfo`].players
                .reduce((acc, player) => {
                    acc[player.number] = {
                        ...player, playing: false,
                        totalPuntos: 0,
                        totalFaltas: 0,
                        teamKey: "A",
                        porCuarto: {}  // {1: {puntos: 0, faltas: 0}, ...}
                    }
                    return acc;
                }, {}),
            faltas: 0,
            faltasPorcuarto: {}
        };
        resumen["B"] = {
            totalPuntos: 0,
            porCuarto: {},  // {1: 10, 2: 5, ...}
            players: gameData.estado[`teamBInfo`].players
                .reduce((acc, player) => {
                    acc[player.number] = {
                        ...player, playing: false,
                        totalPuntos: 0,
                        totalFaltas: 0,
                        teamKey: "B",
                        porCuarto: {}  // {1: {puntos: 0, faltas: 0}, ...}
                    }
                    return acc;
                }, {}),
            faltas: 0,
            faltasPorcuarto: {}
        };
        const eventosSort = eventos.sort((a, b) => a.timestamp - b.timestamp);
        for (const evento of eventosSort) {

            const { tipo, equipo, numero, cantidad = 1, cuarto, numberOut } = evento;
            console.log("evento", tipo);

            if (tipo === "cambio_periodo") {
                console.log("cambio_periodo", cuarto, JSON.stringify(resumen["A"].players))
                resumen.currentPeriod = cuarto;
                setCurrentPeriod(cuarto);


                // saco a todos los jugadores por cambio de cuarto
                resumen["A"].players = Object.fromEntries(
                    Object.entries(resumen["A"].players).map(([key, value]) => [
                        key,
                        { ...value, playing: false }
                    ])
                );
                resumen["B"].players = Object.fromEntries(
                    Object.entries(resumen["B"].players).map(([key, value]) => [
                        key,
                        { ...value, playing: false }
                    ])
                );
                // resumen["B"].players = Object.values(resumen["B"].players).map((a) => ({ [a.number]: { ...a, playing: false } }))

            }

            if (!equipo || !cuarto || !["punto", "falta", "quitar_punto", "quitar_falta", "cambio", "cambiosale"].includes(tipo)) continue;



            const esQuitar = tipo.startsWith("quitar_");
            const tipoBase = tipo.replace("quitar_", ""); // "punto" o "falta"
            const valor = esQuitar ? -cantidad : cantidad;


            // Inicializar estructuras

            console.log("resumen", resumen);
            if (!resumen[equipo].porCuarto[cuarto]) {
                resumen[equipo].porCuarto[cuarto] = 0;
            }
            if (!resumen[equipo].faltasPorcuarto[cuarto]) {
                resumen[equipo].faltasPorcuarto[cuarto] = 0;
            }

            if (numero) {
                if (!resumen[equipo].players[numero]) {
                    resumen[equipo].players[numero] = {
                        number: numero,
                        playing: false,
                        totalPuntos: 0,
                        totalFaltas: 0,
                        porCuarto: {}  // {1: {puntos: 0, faltas: 0}, ...}
                    };
                }

                if (!resumen[equipo].players[numero].porCuarto[cuarto]) {
                    resumen[equipo].players[numero].porCuarto[cuarto] = {
                        puntos: 0,
                        faltas: 0
                    };
                }

                if (tipoBase === "punto") {
                    resumen[equipo].players[numero].totalPuntos += valor;
                    resumen[equipo].players[numero].porCuarto[cuarto].puntos += valor;
                } else if (tipoBase === "falta") {
                    resumen[equipo].players[numero].totalFaltas += valor;
                    resumen[equipo].players[numero].porCuarto[cuarto].faltas += valor;
                }
            }

            // Acumular a nivel de equipo
            if (tipoBase === "punto") {
                resumen[equipo].totalPuntos += valor;
                resumen[equipo].porCuarto[cuarto] += valor;
            }
            if (tipoBase === "falta") {
                resumen[equipo].faltas += valor;
                resumen[equipo].faltasPorcuarto[cuarto] += valor;
            }
            if (tipo === "cambio") {
                console.log("cambio_Jugador", numero, numberOut);

                resumen[equipo].players[numero].playing = true;
                if (resumen[equipo].players[numberOut]) {
                    resumen[equipo].players[numberOut].playing = false;
                }
            }
            if (tipo === "cambiosale") {
                console.log("cambio_Jugador SALE", numero, numberOut);
                resumen[equipo].players[numero].playing = false;
            }
        }


        return resumen;
    }


    const handleMobileAction = (team, index, action, number, numberOut) => {

        console.log("handleMobileAction", action, number, numberOut, currentPeriodIndex);
        const isTeamA = team === "A";
        const teamPlayers = isTeamA ? Object.values(gameStats.A.players) : Object.values(gameStats.B.players);
        console.log("handleMobileAction", teamPlayers);
        //const player = teamPlayers.filter((a) => a.number === number)[0];

        //console.log("handleMobileAction", player);
        const timeNow = Date.now();

        if (["1", "2", "3"].includes(action)) {
            //player.points += parseInt(action);
            saveEvent({ tipo: "punto", equipo: team, numero: number, cantidad: parseInt(action), cuarto: parseInt(currentPeriod), tiempoSegundos: timeNow });
        } else if (["-1", "-2", "-3"].includes(action)) {
            const toSubtract = Math.abs(parseInt(action));
            //player.points = Math.max(0, player.points - toSubtract);
            saveEvent({ tipo: "quitar_punto", equipo: team, numero: number, cantidad: toSubtract, cuarto: parseInt(currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "foul") {
            //console.log("handleMobileAction", player)
            saveEvent({ tipo: "falta", equipo: team, numero: number, cuarto: parseInt(currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "-foul") {
            saveEvent({ tipo: "quitar_falta", equipo: team, numero: number, cuarto: parseInt(currentPeriod), tiempoSegundos: timeNow });
        } else if (action === "cambio") {
            saveEvent({ tipo: "cambio", equipo: team, numero: number, cuarto: parseInt(currentPeriod), tiempoSegundos: timeNow, numberOut: numberOut });
        } else if (action === "cambiosale") {
            saveEvent({ tipo: "cambiosale", equipo: team, numero: number, cuarto: parseInt(currentPeriod), tiempoSegundos: timeNow });
        }

        //teamPlayers[index] = player;


    };

    const handleClockStart = () => {
        const now = Date.now();
        saveClockTimestamps({ startTimestamp: now, pauseTimestamp: null });
        saveEvent({ tipo: "inicio_crono", cuarto: parseInt(currentPeriod), tiempoSegundos: 0 });
    };

    const handleClockPause = () => {
        getClockTimestamps().then(({ startTimestamp }) => {
            const pauseTime = Date.now();
            const elapsed = Math.floor((pauseTime - startTimestamp) / 1000);
            saveClockTimestamps({ startTimestamp, pauseTimestamp: pauseTime });
            saveEvent({ tipo: "pausa_crono", cuarto: parseInt(currentPeriod), tiempoSegundos: elapsed });
        });
    };

    const handleTeamFormSave = (teamKey, data) => {
        console.log("handleTeamFormSave", teamKey, data)
        if (teamKey === "A") {
            dispatch(saveGameData(gameId, { estado: { teamAInfo: data } }))
        } else {
            dispatch(saveGameData(gameId, { estado: { teamBInfo: data } }))
        }
    };

    return (
        <div style={{ padding: 16 }}>
            {/* <SimpleDialogDemo buttonText={"Eventos"}>
                <BasketballEventsList />
            </SimpleDialogDemo> */}
            {/* <Typography variant="h4" align="center" gutterBottom>
                Panel de Juego - Básquetbol Infantil
            </Typography> */}

            {gameData && gameData.estado && gameStats &&
                (<ScoreBoard teamAInfo={gameData.estado.teamAInfo}
                    teamBInfo={gameData.estado.teamBInfo}
                    currentPeriod={gameStats.currentPeriod} gameStats={gameStats} />

                )
            }

            {gameData && gameData.estado && gameStats && gameStats.A && gameStats.B && (

                <QuickScoringMobile
                    teamA={Object.values(gameStats.A?.players)}
                    teamB={Object.values(gameStats.B?.players)}
                    teamAInfo={gameData?.estado?.teamAInfo}
                    teamBInfo={gameData?.estado?.teamBInfo}
                    onAction={handleMobileAction}
                    openTeamConfig={setOpenFormTeam}
                />

            )}

            {gameData && gameData.estado && (


                <TeamPanelForm
                    open={openFormTeam === "A"}
                    teamKey="A"
                    initialData={gameData.estado.teamAInfo}
                    onClose={() => setOpenFormTeam(null)}
                    onSave={(data) => handleTeamFormSave("A", data)}
                />
            )}

            {gameData && gameData.estado && (

                <TeamPanelForm
                    open={openFormTeam === "B"}
                    teamKey="B"
                    initialData={gameData.estado.teamBInfo}
                    onClose={() => setOpenFormTeam(null)}
                    onSave={(data) => handleTeamFormSave("B", data)}
                />
            )}


            <GameClock
                onPeriodTimeChange={(period) => setCurrentPeriod(period)}
                onPeriodEnd={(p) => console.log("Periodo finalizado", p)}
                currentPeriodProp={gameStats.currentPeriod}
                onStart={handleClockStart}
                onPause={handleClockPause}
                initialElapsedTime={initialElapsedTime}
            />
            <EventViewer gameId={gameId} />
        </div>
    );
};

export default GameContainer;
